const MONTHS = [
  'ENERO',
  'FEBRERO',
  'MARZO',
  'ABRIL',
  'MAYO',
  'JUNIO',
  'JULIO',
  'AGOSTO',
  'SEPTIEMBRE',
  'OCTUBRE',
  'NOVIEMBRE',
  'DICIEMBRE'
];

const getFirstDayOfAMonth = (monthParam, yearParam) =>
  new Date(parseInt(yearParam, 10), MONTHS.indexOf(monthParam), 1);

const getLastDayOfAMonth = (monthParam, yearParam) =>
  new Date(parseInt(yearParam, 10), MONTHS.indexOf(monthParam) + 1, 0);

const getAllDays = (locale, startDate, lastDate, format) => {
  const daysBetweenStartAndEnd = [];

  // Crear copias de startDate y lastDate para evitar modificar las originales
  const currentDate = new Date(startDate.getTime());

  while (currentDate <= new Date(lastDate.getTime())) {
    const formattedDate =
      format === 'dd/mm/yy'
        ? currentDate.toLocaleDateString(locale)
        : `${currentDate.toLocaleDateString(locale, {
            weekday: 'long'
          })} ${currentDate.getDate()}`;

    daysBetweenStartAndEnd.push(formattedDate.charAt(0).toUpperCase() + formattedDate.slice(1));

    // Crear una nueva fecha sumando un día a currentDate
    currentDate.setDate(currentDate.getDate() + 1);
  }

  return daysBetweenStartAndEnd;
};

export { getAllDays, getFirstDayOfAMonth, getLastDayOfAMonth };
